import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { legalData } from '../data/mock';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const ImpressumPage = () => {
  const { impressum } = legalData;
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <Header />
      <main className="pt-32 pb-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-dark-grey dark:text-gray-400 hover:text-black dark:hover:text-white transition-colors mb-8">
            <ArrowLeft size={16} />
            {t('backToHome')}
          </Link>
          
          <h1 className="font-display text-4xl md:text-5xl font-bold text-black dark:text-white mb-8">
            Impressum
          </h1>

          <div className="prose prose-lg max-w-none space-y-8 text-dark-grey dark:text-gray-400">

            <section className="bg-grey/10 dark:bg-gray-800 rounded-2xl p-6">
              <h2 className="text-xl font-semibold text-black dark:text-white mb-4">Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)</h2>
              <p className="leading-relaxed whitespace-pre-line">
                {impressum.companyName}{'\n'}
                {impressum.owner}{'\n'}
                {impressum.address}
              </p>
            </section>

            <section className="bg-grey/10 dark:bg-gray-800 rounded-2xl p-6">
              <h2 className="text-xl font-semibold text-black dark:text-white mb-4">Kontakt</h2>
              <p className="leading-relaxed">
                Telefon: {impressum.phone}<br />
                E-Mail: <a href={`mailto:${impressum.email}`} className="text-mid-purple hover:underline">{impressum.email}</a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-black dark:text-white mb-4">Umsatzsteuer-Identifikationsnummer</h2>
              <p className="leading-relaxed">
                Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
                <strong>{impressum.vatId}</strong>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-black dark:text-white mb-4">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
              <p className="leading-relaxed whitespace-pre-line">
                {impressum.owner}{'\n'}
                {impressum.address}
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-black dark:text-white mb-4">EU-Streitschlichtung</h2>
              <p className="leading-relaxed">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-mid-purple hover:underline">
                  https://ec.europa.eu/consumers/odr/
                </a>
              </p>
              <p className="leading-relaxed mt-3">
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-black dark:text-white mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
              <p className="leading-relaxed">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-black dark:text-white mb-4">Haftung für Inhalte</h2>
              <p className="leading-relaxed">
                Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="leading-relaxed mt-3">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-black dark:text-white mb-4">Haftung für Links</h2>
              <p className="leading-relaxed">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
              </p>
              <p className="leading-relaxed mt-3">
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-black dark:text-white mb-4">Urheberrecht</h2>
              <p className="leading-relaxed">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
              </p>
              <p className="leading-relaxed mt-3">
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
              </p>
            </section>

            <section className="bg-grey/10 dark:bg-gray-800 rounded-2xl p-6">
              <p className="text-sm text-mid-grey dark:text-gray-500">
                Quelle: Angepasst unter Berücksichtigung der aktuellen Rechtslage (DDG, MStV). Stand: April 2026.
              </p>
            </section>

          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ImpressumPage;
